// removed by extract-text-webpack-plugin
module.exports = {"root":"_1f-3WGo","types":"_1bknZA_"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/Salary/Salary.less
 ** module id = 923
 ** module chunks = 0
 **/